import React from "react";
import PropTypes from "prop-types";
import { Form } from "antd";

import ProjectSelect from "./ProjectSelect";
import { formItemLayout } from "../../../utils/UI";

const ProjectDropdown = (props) => {
  const { hmgId, value, onChange } = props;

  return (
    <Form.Item label="Project" {...formItemLayout}>
      <ProjectSelect hmgId={hmgId} value={value} onChange={onChange} />
    </Form.Item>
  );
};

ProjectDropdown.defaultProps = {
  hmgId: undefined,
  value: undefined,
};

ProjectDropdown.propTypes = {
  hmgId: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default ProjectDropdown;
